import sapDev from "../images/certificados/sapDev.jpg";
import sapCommerce from "../images/certificados/sapCommerce.jpg";
import java from "../images/java.png";
import js from "../images/certificados/JS.jpg";
import it from "../images/certificados/ITEssentials.jpg";
import Networking_Essen from "../images/certificados/Networking_Essen.jpg";
import commerce from "../images/certificados/commerce-core-developer-certification-exam-LinkedIn-banner.png";
import platform from "../images/certificados/platform-developer-certification-exam-LinkedIn-banner.png";

export const listCertificate = [
  
  {
    id: 1,
    img: sapCommerce,
    title: "SAP Commerce Cloud Business User",
    description:
      "SAP Certified Application Associate - SAP Commerce Cloud Business User",
  },
  {
    id: 2,
    img: sapDev,
    title: "SAP Commerce Cloud 1905 Developer",
    description:
      "SAP Certified Development Professional - SAP Commerce Cloud 1905 Developer",
  },
  {
    id: 6,
    img: commerce,
    title: "Commerce Core Developer",
    description: "Commerce Core Developer",
  },
  {
    id: 7,
    img: platform,
    title: "Platform Developer",
    description: "Platform Developer",
  },
  {
    id: 3,
    img: java,
    title: "JAVA",
    description:
      "Programación en JAVA. Universidad de Chile en alianza con Accenture.",
  },
  {
    id: 4,
    img: js,
    title: "JavaScript",
    description: "Lenguaje JavaScript",
  },
  {
    id: 5,
    img: it,
    title: "Programming Essentials in Python",
    description: "PCAP: Programming Essentials in Python",
  },
  {
    id: 8,
    img: Networking_Essen,
    title: "Networking Essentials",
    description: "Networking Essentials",
  },
];
